import { useNavigate } from 'react-router-dom';
import { AppBar, Box, Button, Toolbar, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';

import {
  LoginCompletionTooltipHost,
  ProfileCompletionBadge,
} from '@features/tenant-profile-hub';
import { useTrans } from '@libs/i18n';
import { StackIcon } from '@phosphor-icons/react';

import { LanguageSwitcher } from './LanguageSwitcher';

export const MainHeader = observer(() => {
  const { t } = useTrans();
  const navigate = useNavigate();

  return (
    <AppBar
      elevation={0}
      position="static"
      sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        maxHeight: '3.25rem',
        bgcolor: 'white',
        borderBottom: '1px solid',
        borderColor: 'divider',
        position: 'relative'
      }}
    >
      <Toolbar sx={{ alignItems: 'center', justifyContent: 'space-between', maxHeight: '3.25rem' }}>
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: 1.5,
          position: 'relative',
        }}>
          <Box component="img" src="/logo.svg" alt="logo" sx={{ height: '32px', width: 'auto', objectFit: 'contain', position: 'relative', zIndex: 1 }} />
          <Typography 
            variant="h6" 
            sx={{ 
              fontWeight: 800, 
              color: '#1A1C1E',
              letterSpacing: '-0.02em',
              fontSize: '1.25rem',
              display: 'flex',
              alignItems: 'center',
              position: 'relative',
              zIndex: 1
            }}
          >
            Komplyance
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Button
            variant="secondary"
            startIcon={<StackIcon size={16} />}
            endIcon={<ProfileCompletionBadge />}
            onClick={() => navigate('/tenant-profile')}
            sx={{ textTransform: 'none', color: 'text.primary' }}
          >
            {t('app.layout.header.organizationHub')}
          </Button>
          <LanguageSwitcher />
          <LoginCompletionTooltipHost />
        </Box>
      </Toolbar>
    </AppBar>
  );
});
